import { makeEntityScaffold } from '@classpass/saga-tools';
import { MultipleSpotsUpdateRequest } from '@classpass/protobuf-definitions/lib/web/models/partners/schedule';

import URLS from 'constants/urls';

const act = (httpClient, venueId, updates) => {
  const endpoint = URLS.venue.smartSpotOpportunitiesBatchUpdate(venueId);

  // Transform updates to match proto field names and serialize with proto
  const requestPayload = {
    updates: updates.map(update => ({
      schedule_id: update.scheduleId,
      spots: update.classpassSpots,
      ss_enabled: update.ssEnabled,
      with_all_futures: update.withAllFutures,
    })),
  };

  const requestBody = MultipleSpotsUpdateRequest.toJSON(requestPayload);

  return httpClient.put(endpoint, requestBody).then(response => {
    // This endpoint returns {results: [...], success_count: 1} directly in response.data
    // Not nested under response.data.data like other endpoints
    return response.data;
  });
};

const handler = ({ httpClient }, { venueId, updates }) => {
  return act(httpClient, venueId, updates);
};

export default makeEntityScaffold('SAGA.API.VENUE.SMARTSPOT_BATCH_UPDATE', handler, {
  defaultKey: (_, { venueId }) => venueId,
});
